import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/voucher-item";

export const exportVoucherReportItem = (obj) => {
  let url = API_PATH + "/export-excel-report-sales-allocation";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
}

// Báo cáo doanh thu cũ mới
export const pagingVoucherItemReport = (obj) =>
  axios.post(API_PATH + "/paging-voucher-item-report", obj);


// Xuất Excel Báo cáo doanh thu cũ mới
export const exportExcelVoucherItemReport = (searchObject) => {
  return axios({
    method: "post",
    url: API_PATH + "/export-excel-voucher-item-report",
    data: searchObject,
    responseType: "blob",
  });
}

export const getVoucherItemRevenueReport = (obj) =>
  axios.post(API_PATH + "/voucher-item-revenue-report", obj);

export const exportExcelRevenueDetailsReport = (obj) => {
  let url = API_PATH + "/export-excel-revenue-details-report";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
}

export const updateLockListVoucherItem = (obj) =>
  axios.post(API_PATH + "/update-lock-list-voucher-item", obj);

export const lockVoucherItemsBySearchReport = (obj) =>
  axios.post(API_PATH + "/lock-voucher-items-by-search", obj);

export const lockAndSendToHRMResult = (obj) =>
  axios.post(API_PATH + "/lock-and-send-to-hrm-result", obj);